export default __webpack_public_path__ + "static/shipmentManagementVp2-2-c2a331cacd943eb533869e76a3f1e42a.png";